import ChatDesktop from "./ChatDesktop"
import ChatMobile from "./ChatMobile"

const ChatRoot = ({ isMobile, setSnackbarMsg }) => {
  return isMobile ? <ChatMobile setSnackbarMsg={setSnackbarMsg} /> : <ChatDesktop setSnackbarMsg={setSnackbarMsg} />
}

export default ChatRoot
